import { type NavCounts, navCountsSchema, queryKeys } from '@mevaser/shared'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import { api } from './api.js'

const POLL_MS = 30_000

/**
 * The red numbers on the sidebar tabs (t1219). One poll covers every tab; the
 * API leaves out tabs you may not see and tabs with nothing waiting. Moving to
 * another page refreshes it, so a count drops soon after an item is handled
 * rather than up to a poll later.
 */
export function useNavCounts(): NavCounts {
  const queryClient = useQueryClient()
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  // biome-ignore lint/correctness/useExhaustiveDependencies: the pathname is the trigger, not a value read inside
  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: queryKeys.navCounts() })
  }, [pathname, queryClient])

  const { data } = useQuery({
    queryKey: queryKeys.navCounts(),
    queryFn: async () => navCountsSchema.parse(await api.get<unknown>('/me/nav-counts')),
    refetchInterval: POLL_MS,
  })
  return data ?? {}
}
